<div class="documents-dialog" *ngIf="active">
  <div class="documents-dialog__content">
    <button class="documents-dialog__content__close" (click)="closeDialog()">
      <span class="material-icons">close</span>Close
    </button>
    <h2>Confirm SMS Opt-Out</h2>
    <ng-container>
      <div class="">
        <div class="mb-10">
          <div>
            <p>
              You’re about to stop receiving SMS notifications for the phone
              number you previously opted in with:
              <b>{{ user.usePhoneForSms ? user.phone : user.phone2 }}</b
              >.
            </p>
            <p>Do you want to proceed?</p>
          </div>
        </div>
        <br />
        <div class="container mt-30">
          <div class="column column-left">
            <div class="documents-dialog__content__footer__service-type">
              <a
                href="https://cretelligent.com/website-terms-of-use/"
                target="_blank"
                rel="noopener noreferrer"
                >Terms & Conditions</a
              >
              <a
                href="https://cretelligent.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                style="margin-left: 22px"
                >Privacy Policy</a
              >
            </div>
          </div>
          <div class="right-columns panelfields">
            <div class="column">
              <button type="submit" class="btn btn-primary" (click)="submit()" [disabled]="isSubmitting">
                Opt-Out
              </button>
            </div>
            <div class="column">
              <button
                type="submit"
                class="btn btn-default"
                (click)="closeDialog()"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="documents-dialog__background" (click)="closeDialog()"></div>
</div>
